import "./Home.css";

export default function Home() {
  return (
    <div className="lean-page">
      <div>
        <section className="intro-section" id="about">
          <h1>Fabian Chua</h1>
          <p className="intro-lede">Product engineer.</p>
          <div className="intro-copy">
            <p>
              I currently work at <a className="org org--iras" href="https://www.iras.gov.sg/" target="_blank" rel="noreferrer">IRAS</a>, reimagining how tax works for people in Singapore.
            </p>
            <p>
              I am an avid learner who is passionate about creating impactful products and implementing designs that make sense. Simply put, I enjoy solving complex problems with good design to simplify our daily lives.
            </p>
            <p>
              Previously, I was a product manager at <a className="org org--binance" href="https://www.binance.com/" target="_blank" rel="noreferrer">Binance</a> and <a className="org org--govtech" href="https://www.tech.gov.sg/" target="_blank" rel="noreferrer">GovTech</a>, and a software engineer at <a className="org org--switcheo" href="https://www.switcheo.com/" target="_blank" rel="noreferrer">Switcheo Labs</a>. I like working across the gap between a messy problem and a product that feels obvious in retrospect.
            </p>
            <p>
              Outside work, I enjoy good food, football, and LinkedIn games recently, lolol.
            </p>
          </div>
        </section>

        <section className="elsewhere-section" id="contact">
          <h2>Reach me</h2>
          <p>
            Find me on <a href="https://www.linkedin.com/in/fabianchua6/" target="_blank" rel="noreferrer">LinkedIn</a> or <a href="mailto:fabianchua6@gmail.com">email</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
